import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Form, Button, Spinner, Alert, Container, Row, Col, Card, CardBody } from 'react-bootstrap';
import { InputField, SelectField, CheckboxField, SuccessToolbar } from '../lib/formControls';
import { apiUrl, apiKey, cryptoService } from '../lib/config';
import { useApiPost } from '../hooks';

import logoImg from '../common/images/loginLogo.png';

/*const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
  password: yup.string().required('Password is required'),
});*/

const schema = yup.object().shape({
  mobile: yup.string()
  .matches(/^[0-9]+$/, "Mobile must contain only numbers")
  .length(10, "Mobile number must be exactly 10 digits")
  .required("Mobile number is required"),
  password: yup.string().required('Password is required'),
});

export default function Login() {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showPasswords, setShowPasswords] = useState(false);
  const rawToken = localStorage.getItem('auth_token');

  useEffect(() => {
    if(rawToken && rawToken.trim() !== '') {
      navigate("/");
    }
  }, []);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    watch,
    reset,
    clearErrors,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onTouched',
    defaultValues: {
      loginType: "mobile",
      email: "",
      mobile: "",
      password: ""
    }
  });

  const [submitted, setSubmitted] = useState(false);
  const [customerror, setCustomerror] = useState('');
  const [isEmptyVal, setIsEmptyVal] = useState(true);
  const { postData, loading, error, responseData } = useApiPost('users/login');


  const watchEmail = watch("email");
  const watchMobile = watch("mobile");
  const watchPassword = watch("password");

  useEffect(() => {
    if (customerror && (watchEmail || watchMobile || watchPassword)) {
      setCustomerror('');
    }
    if ((watchEmail && watchPassword) || (watchMobile && watchPassword)) {
      setIsEmptyVal(false);
    }
  }, [watchEmail, watchMobile, watchPassword]);

  const onSubmit = async (data) => {

      if(data != '' && data != null && Object.keys(data).length > 0) {

        /*let passwordEnct = cryptoService.encryptData(data.password);*/
        let passwordEnct = data.password;
        const payloadObj = {
            password: passwordEnct,
            jwk: true,
            requestFrom: "web",
        };
        if(data.loginType === 'mobile') {
            /*payloadObj.phone = parseInt(data.mobile);*/
            payloadObj.phone = data.mobile;
        } else {
            payloadObj.email = data.email;
        }
        
        let payload = JSON.stringify(payloadObj);
        console.log(payload);

        const { result, error: apiError } = await postData(payload);

        if(result && result?.data) {
            let resultDataObj = result?.data;
            let roleKeyTxt = resultDataObj?.roleKey;
            let entityIdTxt = resultDataObj?.entityIds[0];
            if((roleKeyTxt === "super_admin") || (roleKeyTxt === "bunk_incharge" && entityIdTxt != "")) {
              setSubmitted(true);
              localStorage.setItem('login_info', JSON.stringify(resultDataObj, null, 2));
              localStorage.setItem('auth_token', resultDataObj?.accessToken);
              localStorage.setItem('powerSyncToken', resultDataObj?.powerSyncToken);
              localStorage.setItem('roleKey', roleKeyTxt);
              localStorage.setItem('entityId', entityIdTxt);
              setTimeout(()=>{
                  navigate('/');
              },700);
            } else {
                let errorMsgTxt = (roleKeyTxt === "bunk_incharge" && entityIdTxt === "") ? "Did`t assgin the Bunk for this user." : "You can not access this account.";
                setCustomerror(errorMsgTxt);
            }
        } else {
          setCustomerror(apiError);
        }

    } else {
        localStorage.removeItem("login_info");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("powerSyncToken");
        localStorage.removeItem('roleKey');
        localStorage.removeItem('entityId');
        setCustomerror('Invalid email or password');
    }

  };

  return (<div className="login-page">
              <div className="login-page-innner">
                    <div className="login-page-left">
                          <div className="login-pageleft-main">
                              <div className='login-glassdiv'>
                                  <h5>Access vehicle movement, fuel data, and live monitoring tools.</h5>
                              </div>
                          </div>
                    </div>
                    <div className="login-page-right">
                        <div className="login-pageright-main">
                            <Row className="vh-100 d-flex justify-content-center align-items-center">
                              <Col md={10} lg={10} xl={8}>
                                <Card className="overflow-hidden no-bdr-cls">
                                  <div className="text-center">
                                    <p className='login_logo'>
                                      <img src={logoImg} className='login_logo_img' alt='logo' />
                                    </p>
                                    <h5 className='login_title'>Welcome Back!</h5>
                                    <p className='login_info'>Login to manage all petrol bunks</p>
                                  </div>

                                  {customerror && <Alert variant="danger m-3" dismissible >{customerror}</Alert>}
                                  {submitted && <SuccessToolbar message="🎉 You have been successfully logged in" />}

                                  <CardBody className="pt-0">
                                      <div className='p-2'>
                                      <form className='login-form' onSubmit={handleSubmit(onSubmit)} noValidate>

                                        {/*<InputField
                                          label="Email"
                                          name="email"
                                          type="email"
                                          placeholder="Email Address"
                                          register={register}
                                          errors={errors}
                                          controlclass="mb-3"
                                        />*/}

                                        <InputField
                                          label="Mobile Number"
                                          name="mobile"
                                          type="text"
                                          placeholder="Enter mobile number"
                                          register={register}
                                          errors={errors}
                                          controlclass="mb-3"
                                        />
                                        
                                        <div className="position-relative mb-4">
                                          <InputField
                                            label="Password"
                                            name="password"
                                            type={showPasswords ? "text" : "password"}
                                            placeholder="Password"
                                            register={register}
                                            className="custom-input-pd login-password-input"
                                            errors={errors}
                                          />

                                          <div
                                            className="password-toggle"
                                            onClick={() => setShowPasswords(!showPasswords)}
                                          >
                                            <i className={`bx ${showPasswords ? 'bx-hide' : 'bx-show'}`} />
                                          </div>
                                        </div>
                                        

                                        {/*<div className="forget-passwrd-linkdiv">
                                          <Link to="/forget-passwrd" className="text-muted">
                                            <i className="mdi mdi-lock me-1" />
                                            Forgot your password?
                                          </Link>
                                        </div>*/}

                                        <div className="d-grid">
                                          <Button
                                            type="submit"
                                            disabled={isEmptyVal || isSubmitting || loading}
                                            variant="primary"
                                            className="custom-btn-cls"
                                          >
                                            {loading ? (
                                              <>
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                {' '}Logging in...
                                              </>
                                            ) : (
                                              'Login'
                                            )}
                                          </Button>
                                        </div>

                                      </form>
                                      </div>
                                    </CardBody>

                                </Card>
                              </Col>
                            </Row>
                        </div>
                    </div>
              </div>
        </div>);
}
